import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholiactivities() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Activities',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Activities',
        headingDescription: 'Planning a day out in the countryside? Discover a wide variety of fun-filled Morachi Chincholi activities at Anand Krushi Paryatan Kendra, a 40-acre agri-tourism retreat just 55 km from Pune. Ideal for families, school trips, and corporate outings, this destination offers an exciting mix of nature, adventure, and village life. Guests can enjoy traditional rural experiences like bullock cart and tractor rides, horse riding, boating, and swimming. For extra excitement, there’s a rain dance area and a range of Morachi Chincholi activities including magic shows, puppet shows, and engaging village-style games for kids and adults alike.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Tractor & Bullock Cart Rides",
    "description": "Hop onto a decorated tractor or traditional bullock cart for a peaceful ride through 40 acres of lush farmland—perfect for soaking in rural life and spotting peacocks."
  },
  {
    "title": "Organic Farming Experience",
    "description": "Sow seeds, harvest vegetables, and learn sustainable practices like composting and drip irrigation from local farmers."
  },
  {
    "title": "Traditional Maharashtrian Breakfast",
    "description": "Savor misal-pav, thecha-bhakar, sabudana khichdi, and tea cooked over a wood-fired chulha—served in a bamboo pavilion amidst greenery."
  },
  {
    "title": "Rural Games & Kids Zone",
    "description": "Enjoy classics like lagori, gilli-danda, kho-kho, sack races, plus rope walks, swings, and balance beams—fun for all ages."
  },
  {
    "title": "Bird Watching & Nature Trails",
    "description": "Walk through tamarind groves and water ponds while spotting peacocks, parrots, and kingfishers—ideal for peaceful nature lovers."
  },
  {
    "title": "Dairy & Animal Feeding",
    "description": "Milk cows by hand, feed calves, and visit goats and hens—an educational and joyful experience for children."
  },
  {
    "title": "Maharashtrian Lunch on Banana Leaves",
    "description": "Feast on zunka-bhakar, bharli vangi, dal-rice, and sweet treats served unlimited on fresh banana leaves."
  },
  {
    "title": "Pottery & Handicraft Workshops",
    "description": "Try your hand at clay pottery, diya painting, or jute weaving—guided by local artisans for a hands-on village craft session."
  },
  {
    "title": "Water Splash Zone & Rain Dance",
    "description": "Cool off in kid-friendly pools, colorful slides, and rain-dance zones with peppy music and splash fun."
  },
  {
    "title": "Evening Campfire & Folk Music",
    "description": "Unwind with a bonfire under the stars, enjoy dholki singing, folk stories, and traditional snacks in cozy rural surroundings."
  },
  {
    "title": "Mango Mahotsav & Hurda Party (Seasonal)",
    "description": "Celebrate with mango plucking, aamras, and mango-based treats in summer or roasted jowar hurda with chutney in winter."
  },
  {
    "title": "Agro Learning for Kids",
    "description": "Interactive sessions on farming, food sources, and ecology designed for school children and young visitors."
  }
],




"services": [
  {
    "name": "Top Outdoor Activities in Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra offers a wide variety of outdoor activities for all ages. Whether you’re seeking adventure, education, or simple rural relaxation, visitors can enjoy farm tours, water fun, nature trails, bullock cart rides, and traditional games in a peaceful countryside setting just a short drive from Pune."
  },
  {
    "name": "Bullock Cart Rides and Farm Games",
    "description": "Experience the charm of rural transport with our traditional bullock cart rides through mango orchards and open fields. Pair it with fun farm games like sack races, tug-of-war, and lemon-spoon races to create lasting memories for kids and adults alike."
  },
  {
    "name": "Bird Watching and Nature Trails",
    "description": "Explore the lush surroundings of Morachi Chincholi, known for its large population of peacocks and native birds. Our marked nature trails allow for peaceful walks, bird photography, and eco-education, especially in the early mornings when the trails come alive with chirps and colors."
  },
  {
    "name": "Adventure Rope Activities",
    "description": "Get your adrenaline pumping with our safe and exciting rope activities, including Burma bridge, rope climbing, net crossing, and balancing beams. These are perfect for kids, teens, and even corporate team-building groups looking for adventure in a rural setup."
  },
  {
    "name": "Family Fun Games and Farming Tours",
    "description": "Spend quality time with your family enjoying group activities like kite flying, musical chairs, and mini treasure hunts. Follow it up with a guided farming tour where you’ll get a glimpse into traditional Maharashtrian agriculture practices."
  },
  {
    "name": "Traditional Maharashtrian Village Experiences",
    "description": "Step into a simpler time with our curated village experience. Dress in traditional attire, try your hand at grinding grains or fetching water the old-fashioned way, and learn about rural customs and practices from local hosts who bring stories to life."
  },
  {
    "name": "Pottery and Local Crafts",
    "description": "Get hands-on with clay during our live pottery workshops. Learn from local artisans and try shaping your own pots, toys, or diya lamps. It’s a relaxing and creative way to connect with local culture and take home a handmade souvenir."
  },
  {
    "name": "Guided Farming Experiences",
    "description": "Join a farmer for an immersive walk through the fields where you'll learn how crops are grown, irrigated, and harvested. Get involved with sowing seeds, weeding, or even harvesting seasonal fruits like mangoes or guavas depending on the time of year."
  },
  {
    "name": "Kids Play Zones and Activities",
    "description": "Our dedicated kids’ play area features swings, slides, see-saws, and even mini zip lines. Supervised and safe, this zone lets little ones burn energy while parents unwind in the nearby shaded rest zones or enjoy a farm-fresh snack."
  },
  {
    "name": "Organic Gardening Workshops",
    "description": "Discover the basics of organic farming and sustainable living through our hands-on gardening workshops. Learn composting, seed selection, soil care, and natural pest management—ideal for eco-conscious families and school groups."
  },
  {
    "name": "Cultural Dance and Music Performances",
    "description": "End your day with vibrant Maharashtrian folk dances like Lavani and Lezim, accompanied by traditional instruments and local storytelling. These cultural shows are both entertaining and educational, giving guests a feel of rural Maharashtra’s rich heritage."
  },
  {
    "name": "Campfire Activities",
    "description": "As the sun sets, gather around a warm bonfire under the stars. Enjoy folk music, storytelling, or simple family bonding time. For group bookings, we offer evening snacks and games to enhance the cozy rural experience."
  },
  {
    "name": "Animal Petting Farm Visits",
    "description": "Let children interact with friendly farm animals like goats, hens, ducks, and rabbits. Our petting zone helps build empathy in kids and is a great opportunity for fun learning about animals in a safe, natural environment."
  },
  {
    "name": "Agro Learning Sessions for Children",
    "description": "Designed for schools and young learners, our agro-learning modules include interactive talks and live demos on farming, irrigation, composting, and food sourcing. Every child walks away with practical knowledge and new appreciation for where food comes from."
  },
  {
    "name": "Trekking and Photography Spots",
    "description": "Bring your camera and hiking shoes! Morachi Chincholi’s natural landscapes offer great photo ops—from sunrise over the farms to peacocks roaming freely. Light treks around the farm and nearby hills give adventure lovers a refreshing start to their day."
  }
],
"tableData": [
  ["Top Outdoor Activities in Morachi Chincholi", "- Bullock Cart Rides and Farm Games"],
  ["Bird Watching and Nature Trails", "- Adventure Rope Activities"],
  ["Family Fun Games and Farming Tours", "- Traditional Maharashtrian Village Experiences"],
  ["Pottery and Local Crafts", "- Guided Farming Experiences"],
  ["Kids Play Zones and Activities", "- Organic Gardening Workshops"],
  ["Cultural Dance and Music Performances", "- Campfire Activities"],
  ["Animal Petting Farm Visits", "- Agro Learning Sessions for Children"],
  ["Trekking and Photography Spots", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Peacock Watching in Natural Habitat",
    "WhyChoosedescription": "Morachi Chincholi is famous for its free-roaming peacocks. Early mornings and evenings offer a spectacular sight of peacocks dancing and calling, providing a unique and serene wildlife experience in their natural environment."
  },
  {
    "WhyChooseheading": "Bullock Cart and Tractor Rides",
    "WhyChoosedescription": "Experience rural life with traditional bullock cart rides and tractor tours around the village and farmlands. These activities offer both fun and educational insights into the farming culture of Maharashtra."
  },
  {
    "WhyChooseheading": "Agro-Tourism and Farm Visits",
    "WhyChoosedescription": "Explore organic farms, learn about crop cultivation, and engage in hands-on activities like vegetable picking and animal feeding. Perfect for families, students, and anyone curious about sustainable farming practices."
  },
  {
    "WhyChooseheading": "Adventure and Outdoor Games",
    "WhyChoosedescription": "Enjoy fun activities like zip-lining, rope climbing, archery, and more. Open grounds also allow for traditional outdoor games such as cricket, badminton, and volleyball—great for team bonding and energetic fun."
  },
  {
    "WhyChooseheading": "Cultural Programs and Folk Entertainment",
    "WhyChoosedescription": "Immerse yourself in village culture through folk dances, puppet shows, and music performances. These events highlight the local heritage and provide wholesome entertainment for all age groups."
  },
  {
    "WhyChooseheading": "Seasonal Festivals and Special Events",
    "WhyChoosedescription": "Participate in seasonal events like the Hurda Party in winter and Mango Mahotsav in summer. These festivals celebrate local harvests and offer delicious food, traditional games, and a festive atmosphere unique to rural Maharashtra."
  }
]




















    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What are the main activities at Morachi Chincholi?',
    answer: 'Morachi Chincholi offers a variety of rural and nature-based activities like peacock watching, bullock cart rides, tractor rides, and traditional games.',
  },
  {
    id: 'FAQ2',
    question: 'Can I see peacocks at Morachi Chincholi?',
    answer: 'Yes! Morachi Chincholi is famous for its naturally thriving peacock population. Early morning and evening are the best times for sightings.',
  },
  {
    id: 'FAQ3',
    question: 'Are there any farm-based experiences available?',
    answer: 'Yes, visitors can enjoy hands-on farming experiences such as vegetable picking, irrigation demos, and learning about organic farming practices.',
  },
  {
    id: 'FAQ4',
    question: 'Are adventure activities available at Morachi Chincholi?',
    answer: 'Some agro-resorts offer activities like zip-lining, rope courses, and climbing walls, especially for group bookings and school outings.',
  },
  {
    id: 'FAQ5',
    question: 'Do they offer cultural activities?',
    answer: 'Yes, traditional folk performances, puppet shows, and magic shows are often part of the weekend or festival programs.',
  },
  {
    id: 'FAQ6',
    question: 'What kind of games are available for children?',
    answer: 'Kids can enjoy rural games like Gilli-Danda, marbles, swings, slides, and open spaces for cricket and football.',
  },
  {
    id: 'FAQ7',
    question: 'Is there a rain dance or water activity?',
    answer: 'Yes, many resorts feature rain dance zones with music, as well as small water play areas and pools.',
  },
  {
    id: 'FAQ8',
    question: 'Are there any educational activities?',
    answer: 'Yes, agro-tourism centers offer guided village tours, info on crop cycles, and workshops on sustainable farming.',
  },
  {
    id: 'FAQ9',
    question: 'Can I enjoy traditional Maharashtrian food as part of the activities?',
    answer: 'Absolutely! A big part of the experience is enjoying farm-fresh Maharashtrian thalis made from locally grown ingredients.',
  },
  {
    id: 'FAQ10',
    question: 'Are activities available throughout the year?',
    answer: 'Most activities are available year-round, but monsoon and winter are the most scenic and comfortable times to visit.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nikhil Bhosale, Pune',
    feedback: "The range of activities at Morachi Chincholi kept our whole group entertained — from kids to grandparents. The peacocks were the highlight!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Pawar, Pimpri',
    feedback: "Loved the farm tour and the traditional games. It’s a perfect blend of fun, learning, and relaxation close to Pune.",
    rating: 5,
  },
];























    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Morachi Chincholi Activities",
  "image": "https://morachichincholi.in/assets/images/morachi-chincholi-activities.jpg",
  "description": "Enjoy top outdoor activities at Morachi Chincholi including bullock cart rides, bird watching, adventure ropes, traditional village experiences, pottery, guided farming tours, cultural performances, campfires, and organic gardening workshops.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "900",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/activities"
  }
};




    return (
        <div>
<Helmet>
  <title>Morachi Chincholi Activities | Outdoor Adventures & Cultural Experiences</title>
  <meta 
    name="description" 
    content="Discover top outdoor activities in Morachi Chincholi including bullock cart rides, bird watching, adventure ropes, pottery, farming tours, cultural dances, campfires, and organic gardening workshops for family fun." 
  />
  <meta 
    name="keywords" 
    content="Top outdoor activities in Morachi Chincholi, Bullock cart rides and farm games, Bird watching and nature trails, Adventure rope activities, Family fun games and farming tours, Traditional Maharashtrian village experiences, Pottery and local crafts, Guided farming experiences, Kids play zones and activities, Organic gardening workshops, Cultural dance and music performances, Campfire activities, Animal petting farm visits, Agro learning sessions for children, Trekking and photography spots" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/23.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholiactivities;